import { FunctionComponent } from 'react'
import {
  Box,
  Card,
  CardContent,
  Skeleton,
  Typography,
} from '@black-bear-energy/rucksack'
import { SiteRFPDetails } from '@black-bear-energy/black-bear-energy-common'
import { UserContact } from './UserContact'

export const ContactsCard: FunctionComponent<ContactsCardProps> = ({
  siteRFPDetails,
  isFetching,
}) => {
  return (
    <Card sx={{ flex: '1 0 0' }}>
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          flex: '1 0 0',
        }}
      >
        <Typography variant="h6">Pod Contacts</Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            gap: '16px',
            flex: '1 0 0',
          }}
        >
          {isFetching &&
            new Array(4).fill(0).map((row, index) => (
              <Box
                key={index}
                sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}
              >
                <Skeleton
                  sx={{
                    borderRadius: '100px',
                    height: '32px',
                    width: '32px',
                    transform: 'none',
                  }}
                />
                <Skeleton
                  sx={{ height: '41px', transform: 'none', flex: '1 0 0' }}
                />
              </Box>
            ))}
          {!isFetching && (
            <>
              <UserContact user={siteRFPDetails?.analystUser} role="Analyst" />
              <UserContact user={siteRFPDetails?.driverUser} role="Driver" />
              <UserContact
                user={siteRFPDetails?.contractsUser}
                role="Contracts"
              />
              <UserContact
                user={siteRFPDetails?.constructionUser}
                role="Construction"
              />
            </>
          )}
        </Box>
      </CardContent>
    </Card>
  )
}

export interface ContactsCardProps {
  siteRFPDetails?: SiteRFPDetails | null
  isFetching: boolean
}
